import { gql } from '@apollo/client/core'

export const GET_TREATMENT_CODE = gql`
query TreatmentCodes {
  treatmentCodes {
    code
    description
    isRemapped
    ... on CustomTreatmentCodeGraphql {
      customTreatmentKind
    }
    ... on RegularTreatmentCodeGraphql {
      treatmentKind
    }
  }
}
`

export const GET_WASTE_CODE_EU = gql`
  query GetWasteCodeEU {
    wasteCodes {
      categoryCode
      categoryDescription
      subCategories {
        subCategoryCode
        subCategoryDescription
        codes {
          code
          description
        }
      }
    }
  }
`
